<template>
  <div class="main-ct">
    <div class="header-ct">
      <p>{{ $t('Gamification_Frequently_Asked_Questions_Header') }}</p>
    </div>
    <div class="collapse-container">
      <el-collapse v-for="question in questions" :key="$t(question.question)">
        <el-collapse-item :title="$t(question.question)">
          <p>
            {{ $t(question.answer) }}
          </p>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationFrequentlyAskedQuestions',
  data() {
    return {
      questions: [
        {
          question:
            'Gamification_Frequently_Asked_Questions_Question_Where_Can_I_Learn',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_Where_Can_I_Learn_Answer'
        },
        {
          question:
            'Gamification_Frequently_Asked_Questions_Question_Suitable_For_All_Industries',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_Suitable_For_All_Industries_Answer'
        },
        {
          question: 'Gamification_Frequently_Asked_Questions_Question_Pricing',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_Pricing_Answer'
        },
        {
          question:
            'Gamification_Frequently_Asked_Questions_Question_How_Long_To_Get_Started',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_How_Long_To_Get_Started_Answer'
        },
        {
          question:
            'Gamification_Frequently_Asked_Questions_Question_Offer_Any_Professional_Services',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_Offer_Any_Professional_Services_Answer'
        },
        {
          question:
            'Gamification_Frequently_Asked_Questions_Question_Standalone_Offering',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_Standalone_Offering_Answer'
        },
        {
          question:
            'Gamification_Frequently_Asked_Questions_Question_Benefits_Of_Free_To_Play',
          answer:
            'Gamification_Frequently_Asked_Questions_Question_Benefits_Of_Free_To_Play_Answer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  padding: 60px 100px 120px 100px;
  gap: 15px;
}
.header-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  p {
    text-align: center;
    color: #5c6374;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
  }
}

.collapse-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/deep/ .el-collapse {
  padding: 20px;
  background-color: #fff;
  border: none;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: none;
}

/deep/ .el-collapse-item__header {
  color: #5c6374;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border-bottom: none;
}

/deep/ .el-collapse-item__content {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationFrequentlyAskedQuestions.vue